export default "__VITE_ASSET__CkPy5ODC__"